var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"pa-4 mb-4 white--text text--darken-4"},[_c('legend',{staticClass:"px-1"},[_vm._t("legend",function(){return [_vm._v("Legend")]})],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }